import Vue from 'vue';
import VueRouter from 'vue-router';
import store from '@/store';
import Home from '../views/Home.vue';
import Login from '../views/pages/auth/Login.vue';
import ForgetPassword from '../views/pages/auth/ForgetPassword.vue';
import ResetPassword from '../views/pages/auth/ResetPassword.vue';
import Page403 from '../views/pages/error/Page403.vue';
import Page404 from '../views/pages/error/Page404.vue';

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home,
  },
  // {
  //   path: '/',
  //   name: 'Dashboard',
  //   meta: {
  //     title: "Dashboard | " + store.state.appSettings.company.name,
  //     requiresAuthUser: true,
  //   },
  //   component: () => import('../views/pages/Dashboard.vue') // lazy-loaded
  // },
  {
    path: '/auth/login',
    name: 'Login',
    meta: {
      title: 'Login | ' + store.state.appSettings.company.name,
      requiresGuest: true,
    },
    component: Login,
  },
  {
    path: '/auth/forget-password',
    name: 'ForgetPassword',
    meta: {
      title: 'Forget password | ' + store.state.appSettings.company.name,
      requiresGuest: true,
    },
    component: ForgetPassword,
  },
  {
    path: '/auth/reset-password',
    name: 'ResetPassword',
    meta: {
      title: 'Reset password | ' + store.state.appSettings.company.name,
      requiresGuest: true,
    },
    component: ResetPassword,
  },
  {
    path: '/dashboard',
    name: 'Dashboard',
    meta: {
      title: 'Dashboard | ' + store.state.appSettings.company.name,
      requiresAuthUser: true,
    },
    component: () => import('../views/pages/dashboard/Dashboard.vue'), // lazy-loaded
  },
  {
    path: '/doc-drawer/loan-doc-notification',
    name: 'LoanDocNotification',
    meta: {
      title: 'Loan Doc Notification | ' + store.state.appSettings.company.name,
      requiresAuthUser: true,
    },
    component: () => import('../views/pages/docDrawer/LoanDocNotification.vue'), // lazy-loaded
  },
  {
    path: '/doc-drawer/loan-doc-cover-page-pipeline',
    name: 'LoanDocCoverPagePipeline',
    meta: {
      title: 'Doc Cover Page Pipeline | ' + store.state.appSettings.company.name,
      requiresAuthUser: true,
    },
    component: () => import('../views/pages/docDrawer/LoanDocCoverPagePipeline.vue'), // lazy-loaded
  },
  {
    path: '/doc-drawer/comparison-lock-information',
    name: 'ComparisonLockInformation',
    meta: {
      title: 'Comparison Lock Information | ' + store.state.appSettings.company.name,
      requiresAuthUser: true,
    },
    component: () => import('../views/pages/docDrawer/ComparisonLockInformation.vue'), // lazy-loaded
  },
  {
    path: '/post-closing/purchase-condition-notification',
    name: 'PurchaseConditionNotification',
    meta: {
      title: 'Purchase Condition Notification | ' + store.state.appSettings.company.name,
      requiresAuthUser: true,
    },
    component: () => import('../views/pages/postClosing/PurchaseConditionNotification.vue'), // lazy-loaded
  },
  {
    path: '/post-closing/convert-bundling',
    name: 'ConvertBundling',
    meta: {
      title: 'Convert Bundling | ' + store.state.appSettings.company.name,
      requiresAuthUser: true,
    },
    component: () => import('../views/pages/postClosing/ConvertBundling.vue'), // lazy-loaded
  },
  {
    path: '/underwriting/approval-letter-notification',
    name: 'UWEmailNotification',
    meta: {
      title: 'Approval Letter Notification | ' + store.state.appSettings.company.name,
      requiresAuthUser: true,
    },
    component: () => import('../views/pages/underwriting/ApprovalLetterNotification.vue'), // lazy-loaded
  },
  {
    path: '/underwriting/non-qm-finding-report',
    name: 'NonQmFindingReport',
    meta: {
      title: 'Non-QM Underwriting Report | ' + store.state.appSettings.company.name,
      requiresAuthUser: true,
    },
    component: () => import('../views/pages/underwriting/NonQmFindingReport.vue'), // lazy-loaded
  },
  {
    path: '/underwriting/bank-statement-ai',
    name: 'NonQmFindingReport',
    meta: {
      title: 'Bank Statement AI | ' + store.state.appSettings.company.name,
      requiresAuthUser: true,
    },
    component: () => import('../views/pages/underwriting/BankStatementAI.vue'), // lazy-loaded
  },
  {
    path: '/admin/report/registered-loan-report',
    name: 'RegisteredLoanReport',
    meta: {
      title: 'Registered Loan Report | ' + store.state.appSettings.company.name,
      requiresAuthUser: true,
    },
    component: () => import('../views/pages/admin/reports/RegisteredLoanReport.vue'), // lazy-loaded
  },
  {
    path: '/admin/log-transaction',
    name: 'LogTransaction',
    meta: {
      title: 'Log Transaction | ' + store.state.appSettings.company.name,
      requiresAuthUser: true,
    },
    component: () => import('../views/pages/admin/logs/TransactionLog.vue'), // lazy-loaded
  },
  {
    path: '/admin/user/user-management',
    name: 'UserManagement',
    meta: {
      title: 'User Management | ' + store.state.appSettings.company.name,
      requiresAuthUser: true,
    },
    component: () => import('../views/pages/admin/user/UserManagement.vue'), // lazy-loaded
  },
  {
    path: '/e-sign/e-disclosure',
    name: 'E-Disclosure',
    meta: {
      title: 'E-Disclosure | ' + store.state.appSettings.company.name,
      requiresAuthUser: true,
    },
    component: () => import('../views/pages/e-sign/e-disclosure.vue'), // lazy-loaded
  },
  {
    path: '/e-sign/search-loan',
    name: 'ESignSearchLoan',
    meta: {
      title: 'E-Sign Search Loan | ' + store.state.appSettings.company.name,
      requiresAuthUser: true,
    },
    component: () => import('../views/pages/e-sign/search-loan.vue'), // lazy-loaded
  },
  {
    path: '/e-sign/status-table',
    name: 'ESignStatusTable',
    meta: {
      title: 'E-Sign Status Table | ' + store.state.appSettings.company.name,
      requiresAuthUser: true,
    },
    component: () => import('../views/pages/e-sign/e-sign-status-table.vue'), // lazy-loaded
  },
  {
    path: '/submission/fee-default-setting',
    name: 'FeeDefaultSetting',
    meta: {
      title: 'Fee Default Setting | ' + store.state.appSettings.company.name,
      requiresAuthUser: true,
    },
    component: () => import('../views/pages/submission/FeeDefaultSetting.vue'), // lazy-loaded
  },
  {
    path: '/admin/resources/resource-manager',
    name: 'ResourcesManager',
    meta: {
      title: 'Resources Manager | ' + store.state.appSettings.company.name,
      requiresAuthUser: true,
    },
    component: () => import('../views/pages/admin/resources/ResourcesManager.vue'), // lazy-loaded
  },
  {
    path: '/secondary-marketing/lock-request-pipeline',
    name: 'LockRequestPipeline',
    meta: {
      title: 'Lock Request Pipeline | ' + store.state.appSettings.company.name,
      requiresAuthUser: true,
    },
    component: () => import('../views/pages/secondary-marketing/LockRequestPipeline.vue'), // lazy-loaded
  },
  {
    path: '/secondary-marketing/lock-accept',
    name: 'LockAccept',
    meta: {
      title: 'Lock Accept | ' + store.state.appSettings.company.name,
      requiresAuthUser: true,
    },
    component: () => import('../views/pages/secondary-marketing/LockAccept.vue'), // lazy-loaded
  },
  {
    path: '/secondary-marketing/investor-pricing',
    name: 'InvestorPricing',
    meta: {
      title: 'Investor Pricing | ' + store.state.appSettings.company.name,
      requiresAuthUser: true,
    },
    component: () => import('../views/pages/secondary-marketing/InvestorPricing.vue'), // lazy-loaded
  },
  {
    path: '/secondary-marketing/investor-pricing-detail',
    name: 'InvestorPricing Detail',
    meta: {
      title: 'Investor Pricing Detail | ' + store.state.appSettings.company.name,
      requiresAuthUser: true,
    },
    component: () => import('../views/pages/secondary-marketing/InvestorPricingDetail.vue'), // lazy-loaded
  },
  {
    path: '/loan/pipeline',
    name: 'pipeline',
    meta: {
      title: 'Pipeline | ' + store.state.appSettings.company.name,
      requiresAuthUser: true,
    },
    component: () => import('../views/pages/loan/pipeline.vue'), // lazy-loaded
  },
  {
    path: '/admin/setting/set-default',
    name: 'DefaultSetting',
    meta: {
      title: 'Set Default | ' + store.state.appSettings.company.name,
      requiresAuthUser: true,
    },
    component: () => import('../views/pages/admin/settings/DefaultSetting.vue'), // lazy-loaded
  },
  {
    path: '/admin/security/encryption-decryption',
    name: 'EncryptionDecryption',
    meta: {
      title: 'Encryption Decryption | ' + store.state.appSettings.company.name,
      requiresAuthUser: true,
    },
    component: () => import('../views/pages/admin/security/encryption-decryption.vue'), // lazy-loaded
  },
  {
    path: '/accounting/mortgage-statement-and-good-bye-letter',
    name: 'MortgageStatementAndGoodByeLetter',
    meta: {
      title: 'Mortgage Statement & Good-bye Letter | ' + store.state.appSettings.company.name,
      requiresAuthUser: true,
    },
    component: () => import('../views/pages/accounting/MortgageStatementAndGoodByeLetter.vue'), // lazy-loaded
  },
  {
    path: '/accounting/loan-payment',
    name: 'LoanPayment',
    meta: {
      title: 'Loan Payment | ' + store.state.appSettings.company.name,
      requiresAuthUser: true,
    },
    component: () => import('../views/pages/accounting/LoanPayment.vue'), // lazy-loaded
  },
  {
    path: '/accounting/investor-fee-manager',
    name: 'InvestorFeeManager',
    meta: {
      title: 'Investor Fee Manager | ' + store.state.appSettings.company.name,
      requiresAuthUser: true,
    },
    component: () => import('../views/pages/accounting/InvestorFee/InvestorFeeManager.vue'), // lazy-loaded
  },
  {
    path: '/accounting/investor-fee',
    name: 'Investor Fee Detail',
    meta: {
      title: 'Investor Fee Detail | ' + store.state.appSettings.company.name,
      requiresAuthUser: true,
    },
    component: () => import('../views/pages/accounting/InvestorFee/InvestorFeeDetail.vue'), // lazy-loaded
  },
  {
    path: '/accounting/warehouse-manager',
    name: 'WarehouseManager',
    meta: {
      title: 'Warehouse Manager | ' + store.state.appSettings.company.name,
      requiresAuthUser: true,
    },
    component: () => import('../views/pages/accounting/Warehouse/WarehouseManager.vue'), // lazy-loaded
  },
  {
    path: '/accounting/warehouse-advanced',
    name: 'WarehouseAdvanced',
    meta: {
      title: 'Warehouse Advanced | ' + store.state.appSettings.company.name,
      requiresAuthUser: true,
    },
    component: () => import('../views/pages/accounting/Warehouse/WarehouseAdvance.vue'), // lazy-loaded
  },
  {
    path: '/accounting/warehouse-interest-rate',
    name: 'WarehouseInterestRate',
    meta: {
      title: 'Warehouse Interest Rate | ' + store.state.appSettings.company.name,
      requiresAuthUser: true,
    },
    component: () => import('../views/pages/accounting/Warehouse/WarehouseIntRate.vue'), // lazy-loaded
  },
  {
    path: '/accounting/warehouse-fee',
    name: 'WarehouseFee',
    meta: {
      title: 'Warehouse Fee | ' + store.state.appSettings.company.name,
      requiresAuthUser: true,
    },
    component: () => import('../views/pages/accounting/Warehouse/WarehouseFee.vue'), // lazy-loaded
  },
  {
    path: '/accounting/warehouse-info',
    name: 'WarehouseInfo',
    meta: {
      title: 'Warehouse Info | ' + store.state.appSettings.company.name,
      requiresAuthUser: true,
    },
    component: () => import('../views/pages/accounting/WarehouseInfo.vue'), // lazy-loaded
  },
  {
    path: '/broker/check-broker-license',
    name: 'CheckBrokerLicense',
    meta: {
      title: 'Check Broker License | ' + store.state.appSettings.company.name,
      requiresAuthUser: true,
    },
    component: () => import('../views/pages/broker/CheckBrokerLicense.vue'), // lazy-loaded
  },
  {
    path: '/broker/search-user',
    name: 'SearchUser',
    meta: {
      title: 'Search User | ' + store.state.appSettings.company.name,
      requiresAuthUser: true,
    },
    component: () => import('../views/pages/broker/SearchUser.vue'), // lazy-loaded
  },
  {
    path: '/broker/user-management',
    name: 'UserManagement',
    meta: {
      title: 'User Management | ' + store.state.appSettings.company.name,
      requiresAuthUser: true,
    },
    component: () => import('../views/pages/broker/UserManagement.vue'), // lazy-loaded
  },
  {
    path: '/analytics/pipeline',
    name: 'Pipeline',
    meta: {
      title: 'Pipeline | ' + store.state.appSettings.company.name,
      requiresAuthUser: true,
    },
    component: () => import('../views/pages/analytics/Pipeline.vue'), // lazy-loaded
  },
  {
    path: '/common/bulk-file-upload',
    name: 'BulkFileUpload',
    meta: {
      title: 'Bulk File Upload | ' + store.state.appSettings.company.name,
      requiresAuthUser: true,
    },
    component: () => import('../views/pages/common/BulkFileUpload.vue'), // lazy-loaded
  },
  {
    path: '/common/Automatic-Byte-Info-Update',
    name: 'AutomaticByteInfoUpdate',
    meta: {
      title: 'Automatic Byte Info Update | ' + store.state.appSettings.company.name,
      requiresAuthUser: true,
    },
    component: () => import('../views/pages/common/AutomaticByteInfoUpdate.vue'), // lazy-loaded
  },
  // Announcements routes - IMPORTANT: Specific routes must come BEFORE dynamic routes
  // Example: Add announcement list page (if you want a dedicated list page)
  {
    path: '/announcements',
    name: 'AnnouncementsList',
    meta: {
      title: 'Announcements | ' + store.state.appSettings.company.name,
      requiresAuthUser: true,
    },
    component: () => import('../views/pages/announcements/AnnouncementsPage.vue'), // lazy-loaded
  },
  // Example: Add create announcement page (must come before :announceId)
  // {
  //   path: '/announcements/create',
  //   name: 'CreateAnnouncement',
  //   meta: {
  //     title: 'Create Announcement | ' + store.state.appSettings.company.name,
  //     requiresAuthUser: true,
  //   },
  //   component: () => import('../views/pages/announcement/CreateAnnouncement.vue'), // lazy-loaded
  // },
  // Example: Add edit announcement page (must come before :announceId)
  // {
  //   path: '/announcements/edit/:announceId',
  //   name: 'EditAnnouncement',
  //   meta: {
  //     title: 'Edit Announcement | ' + store.state.appSettings.company.name,
  //     requiresAuthUser: true,
  //   },
  //   component: () => import('../views/pages/announcement/EditAnnouncement.vue'), // lazy-loaded
  // },
  // Dynamic route must come LAST (after all specific routes)
  {
    path: '/announcements/:announceId',
    name: 'AnnouncementDetail',
    meta: {
      title: 'Announcement Detail | ' + store.state.appSettings.company.name,
      requiresAuthUser: true,
    },
    component: () => import('../views/pages/announcements/AnnouncementDetail.vue'), // lazy-loaded
  },
  {
    path: '/error-403',
    name: 'Page403',
    meta: {
      title: 'Access denied | ' + store.state.appSettings.company.name,
    },
    component: Page403,
  },
  {
    path: '*',
    name: 'Page404',
    meta: {
      title: 'Page Not Found | ' + store.state.appSettings.company.name,
    },
    component: Page404,
  },
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
});

router.beforeEach((to, from, next) => {
  document.title = to.meta.title; // Set meta title

  if (to.matched.some((record) => record.meta.requiresAuthUser)) {
    // Routes that requires auth
    // Redirect to login if not authenticated
    if (store.getters['auth/isLoggined']) {
      next();
      // if(store.getters['auth/hasMenuAccess'](to.path)){
      //   next();
      // }
      // else {
      //   next({
      //     path: '/error-403'
      //   });
      // }
    } else {
      // document.title = "Login | " + store.state.appSettings.companyName;
      next({
        path: '/auth/login',
        query: { returnUrl: to.fullPath },
      });
    }
  } else if (to.matched.some((record) => record.meta.requiresGuest)) {
    // Routes that requires guest
    // Redirect to main if authenticated
    if (store.getters['auth/isLoggined'] === true) {
      next({
        path: '/dashboard',
      });
    } else {
      next();
    }
  } else {
    // Always call next
    next();
  }
});

export default router;
